import React, { useState, useEffect, useContext } from "react";
import OtpInputBox from "./OtpInputBox";
import TMSlogo from "../../../../assets/CreditCheckOTP/img/tms-legal-logo.png";
import SecurityImg from "../../../../assets/CreditCheckOTP/img/security-1.png";
import SecureLabel from "../../../../assets/CreditCheckOTP/img/100%-secure.png";
import "../../../../assets/CreditCheckOTP/css/modules/custom.scss";
import "../../../../assets/CreditCheckOTP/css/modules/otp.scss";
import OTPSuccess from "./OTPSuccess";
import OTPFail from "./OTPFail";
import ReferenceContext from "../../../../Contexts/ReferenceContext";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import { useGetCreditAnalysisDataV2 } from "../../../../Hooks/useGetCreditAnalysisDataV2";
import { useHistory } from "react-router-dom";
import { useSkippedLeads } from '../../../../Hooks/useSkippedLeads';
import GtmDataLayer from "../../../../Utility/GtmDataLayer";

const CreditCheck_OTP = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const [otp, setOTP] = useState("");
    const [otpshow, setOtpshow] = useState(true);
    const [isValid, setIsValid] = useState(false);
    const [isInvalid, setIsInvalid] = useState(false);
    const [timeRemaining, setTimeRemaining] = useState(60);
    const [resendDiv, setResendDiv] = useState(false);
    const [error, setError] = useState(false);
    const { referenceID } = useContext(ReferenceContext);
    const { getCreditAnalysisDataV2 } = useGetCreditAnalysisDataV2();
    const { visitorParameters } = useContext(VisitorParamsContext);
    const formData = JSON.parse(localStorage.getItem("formData")) || {};
    const history = useHistory();
    const [btnDisabled, setBtnDisabled] = useState(false);
    const { skippedLeads } = useSkippedLeads();
    const nextPage = urlParams.get("nextPage") || "";
    const splitName = urlParams.get("splitName") || "";

    const handlebtnChange = (otp) => {
        setOTP(otp);
        if (otp.length == 6) {
            setError(false);
        }
    };

    const handleSubmit = async (e) => {
        const uuid = visitorParameters.visitor_parameters.uuid ?? localStorage.getItem("uuid");
        setBtnDisabled(true);
        if (otp.length !== 6) {
            setError(true);
            setBtnDisabled(false);
            return;
        } else {
             GtmDataLayer({
                    question: "otp",
            });
            const res = await getCreditAnalysisDataV2(
                uuid,
                formData,
                "submit_otp",
                { referenceID, otp }
            );

            const redirectUrl =`/credit_check_confirm?uuid=${uuid}`;

            if (res.data.response.status !== "Success") {
                setIsInvalid(true);
                setOtpshow(false);
                setTimeout(() => history.push(redirectUrl + "&splitname=" + splitName + "&nextPage=" + nextPage), 3000);
            } else {
                history.push(redirectUrl + "&splitname=" + splitName + "&nextPage=" + nextPage);
            }
        }
    };

    const handleTimeout = async() => {
        GtmDataLayer({
            question: "otp",
        });
        const skippedLeadsResponse = await skippedLeads(
            "OTP_timeout",
            (visitorParameters.visitor_parameters.uuid ?? localStorage.getItem("uuid")),
            localStorage.getItem("split_name"));
        history.push(
            "/credit_check_confirm?uuid=" +
        (visitorParameters.visitor_parameters.uuid ?? localStorage.getItem("uuid")) + "&splitname=" + splitName + "&nextPage=" + nextPage
        );
    };

    useEffect(() => {
        if (timeRemaining === 0) {
            handleTimeout();
            return;
        }

        const id = setInterval(() => {
            setTimeRemaining((prevTime) => {
                if (prevTime > 0) {
                    return prevTime - 1;
                }
                clearInterval(id);
                return 0;
            });
        }, 1000);
        return () => clearInterval(id);
    }, [timeRemaining]);

    const resendOTP = async (e) => {
        setTimeRemaining(60);
        setResendDiv(true);
        setTimeout(() => {
            setResendDiv(false);
        }, 5000);
        const res = await getCreditAnalysisDataV2(
            visitorParameters.visitor_parameters.uuid ?? localStorage.getItem("uuid"),
            formData,
            "resend_otp",
            { referenceID }
        );
    };

    return (
        <>
            <div className="OTP-Page">
                <section className="otp-section">
                    <div className="container">
                        <div className="brand">
                            <div className="logo pt-4 mb-5">
                                <img src={TMSlogo} height={60} alt="Logo" />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-6">
                                <div
                                    className={`card w-100 otp-card screen3 all-screen p-4 ${otpshow ? "show" : "hide"}`}
                                >
                                    <div className="card-body text-white">
                                        <img
                                            src={SecurityImg}
                                            className="img-fluid mt-4 mb-3"
                                            alt="Security Icon"
                                        />
                                        <h3 className="text-center">Enter Your OTP</h3>
                                        <p className="text-center">
                                            We’ve sent a <strong>6-digit</strong> code to your registered
                                            <strong> mobile number</strong>. Please enter it below to verify your identity.
                                        </p>
                                        <div className="form-group otp-feilds mb-3">
                                            <OtpInputBox
                                                length={6}
                                                onChange={handlebtnChange}
                                                className="form-control"
                                                id="otp"
                                            />
                                        </div>
                                        {error && (
                                            <span className="error_msg mt-2">
                                                Please enter a valid OTP
                                            </span>
                                        )}
                                        <div className="form-group mb-2">
                                            <button
                                                disabled={btnDisabled}
                                                className="otp-verify-btn"
                                                id="verify-otp"
                                                onClick={handleSubmit}
                                            >
                                                Verify OTP
                                            </button>
                                        </div>
                                        <div className="re-function d-flex justify-content-center">
                                            <p className="t-remaing">
                                                <a>Time Remaining : <span>{timeRemaining}</span>s</a>
                                            </p>
                                            {/* <p className="r-otp">
                                                <a onClick={resendOTP}>
                                                    Resend OTP
                                                </a>
                                            </p> */}
                                        </div>
                                        <div>
                                            <p className={`text-center ${resendDiv ? "show" : "hide"}`}>
                                                OTP resend!
                                            </p>

                                        </div>
                                        <div className="scure-label mb-3">
                                            <img src={SecureLabel} className="img-fluid" alt="Secure Label" />
                                            <p className="m-0">
                                                Your security is our priority. This verification step ensures your account remains safe.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <OTPSuccess show={isValid} />
                                <OTPFail show={isInvalid} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default CreditCheck_OTP;
